<div class="background flex flex_column">
	<app-header></app-header>
	<div class="flex1 relative block" aria-hidden>
		<router-outlet></router-outlet>
	</div>
	<app-footer></app-footer>
</div>